<template>
  <auth-general-box>
    <router-view />
    <div class="hidden md:block xl:col-span-7 md:col-span-6">
      <div class="max-w-[80%] mx-auto">
        <div class="my-12 py-12">
          <div class="flex items-center justify-center h-full">
            <!-- swiper -->
            <div class="swiper" id="swiper_one">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="slide in slides"
                  :key="slide.Id"
                >
                  <div class="swiper-slide-content">
                    <div class="text-center w-3/5 mx-auto">
                      <img :src="slide.Image" class="w-full" />
                    </div>
                    <div class="text-center my-6 pb-12">
                      <h5
                        class="font-medium text-base/[1.6] text-gray-600 my-2.5"
                      >
                        {{ slide.Title }}
                      </h5>
                      <p class="text-sm/[1.6] text-gray-500 mb-4">
                        {{ slide.Description }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- swiper-slide End -->
              </div>
              <!-- swiper-wrapper End -->
              <div class="swiper-pagination !bottom-0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </auth-general-box>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AuthGeneralBox from "@/components/AuthLayout/AuthGeneralBox.vue";
import { Swiper } from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import { fetchSlides } from "@/services/contentService";

const slides = ref([]);

onMounted(async () => {
  var response = await fetchSlides();

  slides.value = response;

  // Swiper'ı başlat
  setTimeout(() => {
    new Swiper("#swiper_one", {
      modules: [Autoplay, Pagination],
      loop: true,
      autoplay: {
        delay: 3000, // 3 saniye
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }, 100); // DOM'un render olması için kısa bir gecikme
});
</script>
